import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TaskPopupComponent } from './task-popup.component';

const routes: Routes = [{ path: '', component: TaskPopupComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TaskPopupRoutingModule { }
